import { Input } from '@ui-kit/Input';
import { PropsDigineticaInput } from './PropsDigineticaInput';
import { ErrorBoundaryComponent } from '@sharedUi/ErrorBoundary';
import classNames from 'classnames';

import styles from './DigineticaInput.module.scss';

const placeholderText = 'Поиск, пример, шины 205 55 16';

export const DigineticaInput = ({ className, placeholder = placeholderText }: PropsDigineticaInput): JSX.Element => {
  return (
    <ErrorBoundaryComponent>
      <form id={'formSearchDiginetica'} className={classNames(styles.DigineticaInput, className)}>
        <Input id="inputSearchDiginetica" className={'search-form__input'} placeholder={placeholder} data-testid="header-input-diginetica" />
      </form>
    </ErrorBoundaryComponent>
  );
};
